// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WLr4","rightAdornment":"Header_rightAdornment__266Aa"};